import * as THREE from 'three';
import {FBXLoader} from 'three/examples/jsm/loaders/FBXLoader.js';
import {EXRLoader} from 'three/examples/jsm/loaders/EXRLoader.js';
// @ts-ignore
import objData from '../../data/bar/objects.json';

export const vertexShader = require('../shader/vertexShader.glsl');
export const fragmentShader = require('../shader/fragmentShader.glsl');
export const devVert = require('../shader/devVert.glsl');
export const devFra = require('../shader/devFra.glsl');
export default class Bar {
    private _geometry: THREE.BufferGeometry | null = null;
    private _positionTex: THREE.Texture | null = null;
    private _material: THREE.ShaderMaterial;
    private _mesh: THREE.Mesh;
    private time: number=0;
    private scene: THREE.Scene;
    private FBXLoader = new FBXLoader();
    private _index;
    private _w: number = 500;
    private _h: number = 500;
    private _uScale: number = 10;
    private model:string ='';
    private _childMeshes: {mesh: THREE.Mesh, origMat: THREE.Material}[] = [];
    private _wireMaterial = new THREE.MeshBasicMaterial({ color: 0x111111, wireframe: true });
    private _viewMode: 'normal' | 'wireframe' | 'noMaterial' = 'normal';

    constructor(scene: THREE.Scene,index:number) {
        this.scene = scene;
        this._index = index;
        this._uScale = 15.;
        this._w=window.innerWidth
        this._h=window.innerHeight
        this._doInit();

    }

    async _doInit() {
        this.model = `/data/bar/Cylinder0${this._index+1}.fbx`;
        this.loadGLB();
    }

    private loadGLB() {
        this.FBXLoader.load(this.model, (object) => {

            object.scale.set(
                this._uScale,
                this._uScale,
                this._uScale,
            );
            object.position.y += 6.0; // 床面すれすれで止める（zファイト回避）
            const thinMatrix = new THREE.Matrix4().makeScale(1, 1, 1);
            object.traverse((child: any) => {
                if (child.isMesh) {
                    const mat = new THREE.MeshStandardMaterial({
                        color: 0xF2C832,
                        roughness: 0.3,
                        metalness: 0.2,
                        polygonOffset: true,
                        polygonOffsetFactor: 1,
                        polygonOffsetUnits: 1,
                    });
                    child.material = mat;
                    child.castShadow = true;
                    child.receiveShadow = true;
                    // シャドウマップ用: XZを太くして影を大きく
                    const shadowScale = 1.4;
                    const depthMat = new THREE.MeshDepthMaterial({
                        depthPacking: THREE.RGBADepthPacking,
                    });
                    depthMat.onBeforeCompile = (shader) => {
                        shader.vertexShader = shader.vertexShader.replace(
                            '#include <begin_vertex>',
                            `#include <begin_vertex>
                            transformed.xz *= ${shadowScale.toFixed(1)};`
                        );
                    };
                    child.customDepthMaterial = depthMat;

                    // ContactShadow用: 同様に太くした黒シルエット
                    const contactMat = new THREE.MeshBasicMaterial({ color: 0x000000 });
                    contactMat.onBeforeCompile = (shader) => {
                        shader.vertexShader = shader.vertexShader.replace(
                            '#include <begin_vertex>',
                            `#include <begin_vertex>
                            transformed.xz *= ${shadowScale.toFixed(1)};`
                        );
                    };
                    child.userData.contactShadowMaterial = contactMat;
                    // ジオメトリの断面だけ細くする（位置・間隔には影響しない）
                    child.geometry = child.geometry.clone();
                    child.geometry.applyMatrix4(thinMatrix);
                    this._childMeshes.push({ mesh: child, origMat: mat });
                }
            });
            this.tryInit();
            this.scene.add(object);
        });
    }

    private tryInit() {

        if (!this._geometry) return;

        this.initMesh();
    }

    private initMesh() {
        // this._material = new THREE.MeshBasicMaterial({color: 0x6699FF});
        // this._mesh = new THREE.Mesh(this._geometry!, this._material);
        // this._mesh.rotateX(15);
        // this.scene.add(this._mesh);
    }

    setViewMode(mode: 'normal' | 'wireframe' | 'noMaterial'): void {
        this._childMeshes.forEach(({ mesh, origMat }) => {
            if (mode === 'normal') {
                mesh.material = origMat;
            } else if (mode === 'wireframe') {
                mesh.material = this._wireMaterial;
            } else {
                mesh.material = this._wireMaterial;
            }
        });
    }

    resized(): void {

    }
    updated(): void {
        this.time += .5;
        if (this._material) {
            // this._material.uniforms.uTime.value = this.time;
        }
    }
}
